import { SUPPLIER_CRM_PATH } from './constants';
import { CreateSupplierPayload, Supplier } from './suppliers.types';
import { api } from '../../axiosClient';

export const postSupplier = (
  data: CreateSupplierPayload,
): Promise<Supplier> => {
  return api.post(SUPPLIER_CRM_PATH, data);
};
